import { IJobForm } from 'jobs/types';

export const mapUpsertJobForm = (data: IJobForm, projectId?: number) => {
  let projectData = { projectId };

  if (!projectId) {
    projectData = {
      projectId: data.project?.id,
    };
  }

  return {
    bom: { jobName: data.jobName, disciplineId: data.discipline?.id, ...projectData },
  };
};
